import { http } from './http'
import type { ApiResponse } from '../types/api'

export type LoginResponse = {
  token: string;
  user: {
    id: number;
    username: string;
    role: string;     // "admin" | "manager" | "inspector"
    roleName: string; // ชื่อไทย
  };
};

export async function login(username: string, password: string): Promise<LoginResponse> {
  const res = await http.post<ApiResponse<LoginResponse>>('/auth/login', { username, password })

  if (!res.data.success || !res.data.data) {
    throw new Error(res.data.error || 'Login failed')
  }

  return res.data.data   // ✅ ตรงนี้ Type = LoginResponse
}
